export const IMPORT_VENUES_FAILED_MESSAGE = 'Could not import venues';
